import {useEffect,useState} from "react";
import api from "../../../api/api";
export default function ActionListEditor({
  actions = [],
  onChange,
  notifications = [],
  statusOptions = [],
  categoryOptions = [],
  subcategoryOptions = [],
  users = [],
}) {
  const [routing,setRouting]=useState({enabled:false,departments:[],schools:[],types:[]});
  const [routingError,setRoutingError]=useState('');
  useEffect(()=>{let active=true;api('/helpdesk/admin/rules/options/lifecycle').then(data=>{if(active)setRouting(data);}).catch(e=>{if(active)setRoutingError(e.message);});return()=>{active=false;};},[]);

  function normaliseActionOrder(updatedActions) {
    return updatedActions.map((action, index) => ({
      ...action,
      action_order: index,
    }));
  }

  function updateActions(updatedActions) {
    onChange(normaliseActionOrder(updatedActions));
  }

  function updateAction(index, changes) {
    const updated = [...actions];

    updated[index] = {
      ...updated[index],
      ...changes,
    };

    updateActions(updated);
  }

  function changeActionType(index, actionType) {
    updateAction(index, {
      action_type: actionType,
      params: {},
    });
  }

  function updateParams(index, params) {
    updateAction(index, {
      params,
    });
  }

  function addAction() {
    updateActions([
      ...actions,
      {
        action_type: "notify",
        action_order: actions.length,
        params: {},
      },
    ]);
  }

  function removeAction(index) {
    updateActions(actions.filter((_, i) => i !== index));
  }

  function moveAction(index, direction) {
    const targetIndex = index + direction;

    if (targetIndex < 0 || targetIndex >= actions.length) {
      return;
    }

    const updated = [...actions];

    [updated[index], updated[targetIndex]] = [
      updated[targetIndex],
      updated[index],
    ];

    updateActions(updated);
  }

  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold">Actions</label>
      {routingError&&<p role="alert">Routing options unavailable: {routingError}</p>}

      {actions.map((action, index) => (
        <div
          key={index}
          className="border rounded p-3 space-y-3"
        >
          <div className="flex gap-2 items-center">
            <span className="text-sm text-gray-500 w-6">
              {index + 1}.
            </span>

            <select
              className="border p-2 flex-1"
              value={action.action_type}
              onChange={(e) =>
                changeActionType(index, e.target.value)
              }
            >
              <option value="notify">Notify</option>
              <option value="set_status">Set ticket status</option>
              <option value="set_category">Set category</option>
              <option value="set_subcategory">Set subcategory</option>
              <option value="assign_ticket">Assign ticket</option>
              <option value="send_message">Send message</option>
              <option value="close_ticket">Close ticket</option>
              {routing.enabled&&<><option value="set_department">Transfer to department</option><option value="set_school">Transfer to school</option><option value="set_ticket_type">Set ticket type</option></>}
            </select>

            <button
              type="button"
              disabled={index === 0}
              onClick={() => moveAction(index, -1)}
              className="px-2 py-1 border rounded disabled:opacity-40"
              title="Move up"
            >
              ↑
            </button>

            <button
              type="button"
              disabled={index === actions.length - 1}
              onClick={() => moveAction(index, 1)}
              className="px-2 py-1 border rounded disabled:opacity-40"
              title="Move down"
            >
              ↓
            </button>

            <button
              type="button"
              onClick={() => removeAction(index)}
              className="px-2 py-1 border rounded text-red-600"
            >
              Remove
            </button>
          </div>

          {['set_department','set_school','set_ticket_type'].includes(action.action_type)&&(()=>{
            const key=action.action_type==='set_department'?'departmentId':action.action_type==='set_school'?'schoolId':'ticketTypeId';
            const choices=action.action_type==='set_department'?routing.departments:action.action_type==='set_school'?routing.schools:routing.types;
            return <div><select aria-label={`Destination for action ${index+1}`} className="border p-2 w-full" value={action.params?.[key]||''} onChange={e=>updateParams(index,{[key]:key==='departmentId'?e.target.value:Number(e.target.value)})}><option value="">Select destination</option>{choices.map(choice=><option key={choice.id} value={choice.id}>{choice.name}</option>)}</select><p className="text-sm">Department/school transfers set New, preserve elapsed time and apply destination targets. Default and resolved-ticket transfers are prohibited.</p></div>;
          })()}

          {action.action_type === "notify" && (
            <select
              className="border p-2 w-full"
              value={action.params?.notificationId || ""}
              onChange={(e) =>
                updateParams(index, {
                  notificationId: e.target.value,
                })
              }
            >
              <option value="">Select notification</option>

              {notifications.map((notification) => (
                <option
                  key={notification.id}
                  value={notification.id}
                >
                  {notification.name}
                </option>
              ))}
            </select>
          )}

          {action.action_type === "set_status" && (
            <select
              className="border p-2 w-full"
              value={action.params?.statusId || ""}
              onChange={(e) =>
                updateParams(index, {
                  statusId: Number(e.target.value),
                })
              }
            >
              <option value="">Select status</option>

              {statusOptions.map((status) => (
                <option key={status.id} value={status.id}>
                  {status.name}
                </option>
              ))}
            </select>
          )}

          {action.action_type === "set_category" && (
            <select
              className="border p-2 w-full"
              value={action.params?.categoryId || ""}
              onChange={(e) =>
                updateParams(index, {
                  categoryId: Number(e.target.value),
                })
              }
            >
              <option value="">Select category</option>

              {categoryOptions.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          )}

          {action.action_type === "set_subcategory" && (
            <select
              className="border p-2 w-full"
              value={action.params?.subcategoryId || ""}
              onChange={(e) =>
                updateParams(index, {
                  subcategoryId: Number(e.target.value),
                })
              }
            >
              <option value="">Select subcategory</option>

              {subcategoryOptions.map((subcategory) => (
                <option
                  key={subcategory.id}
                  value={subcategory.id}
                >
                  {subcategory.name}
                </option>
              ))}
            </select>
          )}

          {action.action_type === "assign_ticket" && (
            <div className="space-y-2">
              <select
                className="border p-2 w-full"
                value={
                  action.params?.userSource === "event_actor"
                    ? "event_actor"
                    : "specific_user"
                }
                onChange={(e) => {
                  if (e.target.value === "event_actor") {
                    updateParams(index, {
                      userSource: "event_actor",
                    });
                  } else {
                    updateParams(index, {
                      userSource: "specific_user",
                      userId: "",
                    });
                  }
                }}
              >
                <option value="event_actor">
                  Person who triggered the rule
                </option>
                <option value="specific_user">
                  Specific user
                </option>
              </select>

              {action.params?.userSource !== "event_actor" && (
                <select
                  className="border p-2 w-full"
                  value={action.params?.userId || ""}
                  onChange={(e) =>
                    updateParams(index, {
                      userSource: "specific_user",
                      userId: Number(e.target.value),
                    })
                  }
                >
                  <option value="">Select user</option>

                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.name || user.email}
                      {user.name && user.email
                        ? ` (${user.email})`
                        : ""}
                    </option>
                  ))}
                </select>
              )}
            </div>
          )}

          {action.action_type === "send_message" && (
            <div className="space-y-2">
              <select
                className="border p-2 w-full"
                value={action.params?.visibility || "public"}
                onChange={(e) =>
                  updateParams(index, {
                    ...action.params,
                    visibility: e.target.value,
                    ...(e.target.value==='internal'?{isClarification:false}:{}),
                  })
                }
              >
                <option value="public">Public reply</option>
                <option value="internal">Internal note</option>
              </select>

              {routing.enabled&&(action.params?.visibility||'public')==='public'&&<label className="block text-sm"><input type="checkbox" checked={action.params?.isClarification===true} onChange={e=>updateParams(index,{...action.params,isClarification:e.target.checked})}/> Clarification request in Default (sets Waiting for User; no SLA response completion)</label>}
              <textarea
                className="border p-2 w-full min-h-24"
                placeholder="Message"
                value={action.params?.body || ""}
                onChange={(e) =>
                  updateParams(index, {
                    ...action.params,
                    body: e.target.value,
                  })
                }
              />
            </div>
          )}
        </div>
      ))}

      <button
        type="button"
        onClick={addAction}
        className="px-3 py-1 border rounded"
      >
        + Add action
      </button>
    </div>
  );
}